var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestiicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.751099,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0675F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 19.4178H34.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35.4177V30.0844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 34.0848C21.6597 31.4927 22.9261 29.1106 24.8922 27.3903C26.8584 25.6699 29.3875 24.7309 31.9999 24.7514C33.7253 24.7533 35.4245 25.1736 36.9518 25.9764C38.479 26.7793 39.7887 27.9406 40.7685 29.3608C41.7483 30.781 42.369 32.4177 42.5772 34.1305C42.7855 35.8432 42.5752 37.581 41.9643 39.1946C41.3535 40.8083 40.3603 42.2496 39.0699 43.3951C37.7796 44.5405 36.2307 45.3559 34.556 45.7712C32.8813 46.1865 31.1309 46.1893 29.4549 45.7795C27.7789 45.3696 26.2273 44.5593 24.9333 43.4181L21.3333 40.2181",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 39.4178H21.3333V46.0845",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestiicon3);
export default __webpack_public_path__ + "static/media/destiicon3.50fca620f27b52428b3d80bc7ce61a8e.svg";
export { ForwardRef as ReactComponent };